import {
    $,
    isMobile,
    currentDocument,
    currentWindow,
    currentLocation,
    currentHost,
    navigate,
    viewportWidth,
    viewportHeight, downloadFile, selfDownload, parseJwt, currentGoogle, getUTMSource
} from './browser';
import {getCookie, deleteCookie, saveCookie, saveUTMSourceCookie} from './cookies';
import {Config} from './config';

export interface IAttributes {
    cfType: string;
    cfScrId: string;
    cfScrTitle: string;
    cfHref: string;
    cfFile: string;
    cfPPT: string;
    cfProgramType: string;
    cfPaymentTypeRequest: string;
    cfPricingCurrency: string;
}

function closeDialog(elementId: string) {
    let result = 'success';
    try {
        $(elementId).dialog('destroy').remove();
    } catch (e) {
        result = e;
    }
    return result;
}

function addClassStyle(): void {
    try {
        const sheet: HTMLStyleElement = currentDocument.createElement('style');
        sheet.id = 'contact-form-style-for-dialog';
        sheet.innerHTML = `.ui-dialog.noUIStuffForContactForm .ui-dialog-titlebar {display:none !important;}
        .ui-dialog.noUIStuffForContactForm {left: calc(50% - 250px)!important;top: 76px!important;box-shadow: 0px 3px 6px #00000029!important;border: none; padding:0; overflow:hidden; background: transparent; z-index: 99999999 !important; position: fixed;}
        .ui-dialog.noUIStuffForContactForm .ui-dialog-content {border: none !important; padding:0 !important; overflow:hidden !important; background: transparent !important;}
        .ui-widget.noUIStuffForContactForm  {border: none !important; padding:0 !important; overflow:hidden !important; background: transparent !important;}
        .ui-widget-content.noUIStuffForContactForm  {border: none !important; padding:0 !important; overflow:hidden !important; background: transparent !important;}
        .ui-dialog.noUIStuffForContactForm ~ .ui-widget-overlay {background: rgb(112, 112, 112)!important;opacity: .5!important;}`;
        currentDocument.body.appendChild(sheet);
    } catch (err) {
        console.log('addClassStyle ', {err});
    }
}

function generateFormURL(attributes: IAttributes): string {
    const currentURL: string = (currentLocation) ? currentLocation.href || '' : '';
    const params = {
        screenId: attributes.cfScrId,
        screenTitle: attributes.cfScrTitle,
        formType: attributes.cfType,
        dialogId: Config.ADCORE_CONTACT_FORM_DIALOG_MODAL,
        navigateUrl: attributes.cfHref,
        downloadUrl: attributes.cfFile,
        currentUrl: currentURL,
        pricingProgramType: attributes.cfPPT,
        programType: attributes.cfProgramType,
        paymentTypeRequest: attributes.cfPaymentTypeRequest,
        pricingCurrency: attributes.cfPricingCurrency
    };
    const u = new URLSearchParams(params).toString();
    // console.log({params, u});
    return `${currentHost}/uiContactForm/?${u}`;
}

function openDialog(attributes: IAttributes): void {
    let status = false;
    try {
        const div: any = currentDocument.getElementById(Config.ADCORE_CONTACT_FORM_DIALOG_MODAL);
        status = (div) ? $(`#${Config.ADCORE_CONTACT_FORM_DIALOG_MODAL}`).dialog('isOpen') : false;
    } catch (e) {
    }
    if (!status) {
        //calc(100vw * 16 / 9)
        //width: 100vw; height: 100vh; margin: 0; padding: 0;
        //max-width: 501px; max-height: 658px;
        // width: 501,
        // height: 658,
        // width: 'auto',
        // height: 'auto',
        let vpWidth = viewportWidth;
        let vpHeight = viewportHeight;
        console.log('view port ', {vpWidth, vpHeight});
        if (vpWidth > 501) {
            vpWidth = 501;
        } else {
            vpWidth *= 0.5;
        }
        if (vpHeight >= 658) {
            vpHeight = 658;
        } else {
            vpHeight -= 20;
        }
        // min-height: -moz-available; min-height: -webkit-fill-available;  min-height: fill-available;
        const iframe = $(`<iframe src="${generateFormURL(attributes)}" 
        style="box-sizing: border-box !important; min-height: -moz-available; min-height: -webkit-fill-available;
        border:none; overflow:hidden !important; width: ${vpWidth}px !important; height: ${vpHeight}px !important; 
        margin: !important; padding: !important; max-width: 501px; max-height: 658px;border-radius: 10px;"></iframe>`);
        const dialog = $(`<div id="${Config.ADCORE_CONTACT_FORM_DIALOG_MODAL}"></div>`)
            .append(iframe)
            .appendTo('body')
            .dialog({
                autoOpen: false,
                draggable: false,
                closeOnEscape: true,
                stack: true,
                modal: true,
                resizable: false,
                width: 'auto',
                height: 'auto',
                maxWidth: 501,
                maxHeight: 658,
                dialogClass: 'noUIStuffForContactForm',
                appendTo: 'body',
                position: {my: 'center', at: 'center', of: $('body')},
                open: (event: any, ui: any) => {
                    $('.ui-widget-overlay').bind('click', function() {
                        $(`#${Config.ADCORE_CONTACT_FORM_DIALOG_MODAL}`).dialog('destroy').remove();
                    });
                }
            });
        dialog.dialog('open');
    } else {
        $('.ui-widget-overlay').bind('click', function() {
            $(`#${Config.ADCORE_CONTACT_FORM_DIALOG_MODAL}`).dialog('destroy').remove();
        });
    }
}

function handleOneTapGoogleCredentialResponse(response: any) {
    let responsePayload = parseJwt(response.credential);

    // console.log("ID: " + responsePayload.sub);
    // console.log('Full Name: ' + responsePayload.name);
    // console.log('Given Name: ' + responsePayload.given_name);
    // console.log('Family Name: ' + responsePayload.family_name);
    // console.log("Image URL: " + responsePayload.picture);
    // console.log('Email: ' + responsePayload.email);
    if (!responsePayload || !responsePayload.email || !responsePayload.name) {
        return;
    }
    let cookieToSave = {fullName: responsePayload.name, firstName: responsePayload.given_name || '',
        lastName: responsePayload.family_name || responsePayload.name,
        message: '', phone: null, email: responsePayload.email, provider: 'google'}

    // console.log('handleOneTapGoogleCredentialResponse: ', {responsePayload});
    let currentURL: string = (currentLocation) ? currentLocation.href || '' : '';
    let fields: any[] = [
        {
            name: 'firstname',
            value: responsePayload.given_name || '  '
        },
        {
            name: 'lastname',
            value: responsePayload.family_name || responsePayload.name
        },
        {
            name: 'email',
            value: responsePayload.email
        },
        {
            name: 'program',
            value: 'Blog subscribers'
        },
        {
            name: 'lead_source',
            value: 'Inbound'
        },
        {
            name: 'website_lead_made_with',
            value: 'Google One Tap'
        }
    ];

    let legalConsentOptions: any = { // Include this object when GDPR options are enabled
        consent: {
            consentToProcess: true,
            text: 'I agree to allow Example Company to store and process my personal data.',
            communications: [
                {
                    value: true,
                    subscriptionTypeId: 999,
                    text: 'I agree to receive marketing communications from Example Company.'
                }
            ]
        }
    };
    let context: any = {
        pageUri: currentURL,
        pageName: currentURL
    };
    if (getCookie('hubspotutk')) {
        context.hutk = getCookie('hubspotutk') || '';
    }
    let params = {skipValidation: true, fields, context, legalConsentOptions};
    let PORTAL_ID = '6962858';
    let FORM_ID = '08fff184-36cf-44e5-8cdd-e35650783d70';
    let apiUrl = `https://api.hsforms.com/submissions/v3/integration/submit/${PORTAL_ID}/${FORM_ID}`;
    $.ajax({
        url: apiUrl,
        type: 'POST',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        data: JSON.stringify(params),
        success: (result) => {
            console.log('success hsforms: ',  {result});
            saveCookie(Config.ADCORE_CONTACT_FORM_COOKIE, cookieToSave);
        }
    });
}

function onClick(attributes: IAttributes): void {
    // console.log(`cookie exist  ${!!getCookie(Config.ADCORE_CONTACT_FORM_COOKIE)}   and values: `, {
    //     cfType,
    //     cfScrId,
    //     cfScrTitle,
    //     cfHref
    // });

    if (getCookie(Config.ADCORE_CONTACT_FORM_COOKIE) && attributes.cfScrId) {
        if (['content', 'download_link'].includes(attributes.cfScrId)) {
            navigate(attributes.cfHref);
            if (attributes.cfFile) {
                selfDownload(`https://cf-ng.adcore.com/download/?fileUrl=${attributes.cfFile}`);
            }
            return;
        }
        if (['download'].includes(attributes.cfScrId)) {
            selfDownload(`https://cf-ng.adcore.com/download/?fileUrl=${attributes.cfHref}`);
        }
    }
    if (!isMobile) {
        openDialog(attributes);
    } else {
        navigate(generateFormURL(attributes), '_self');
    }
}

export const loadApp = () => {
    currentWindow.handleOneTapGoogleCredentialResponse = handleOneTapGoogleCredentialResponse;
    addClassStyle();
    currentWindow.deleteAdcoreFormCookie = () => {
        deleteCookie(Config.ADCORE_CONTACT_FORM_COOKIE);
    };
    currentWindow.closeDialog = (elementId: string, shouldNavigate: boolean, navigateUrl: string, downloadUrl?: string) => {
        closeDialog(elementId);
        shouldNavigate && navigate(navigateUrl);
        shouldNavigate && downloadUrl && selfDownload(`https://cf-ng.adcore.com/download/?fileUrl=${downloadUrl}`);
    };
    const buttons: HTMLElement[] = currentDocument.querySelectorAll('[data-contact-form-type]');
    buttons.forEach((button: HTMLElement) => {
        const cfType: string = button.getAttribute('data-contact-form-type') || 'portal';
        const cfScrId: string = button.getAttribute('data-contact-form-screen-id') || 'lets_talk';
        const cfScrTitle: string = button.getAttribute('data-contact-form-screen-title') || '';
        const cfHref: string = button.getAttribute('href') || button.getAttribute('data-contact-form-href') || '';
        const cfFile: string = button.getAttribute('data-contact-form-file') || '';
        const cfPPT: string = button.getAttribute('data-contact-form-ppt') || '';
        const cfProgramType: string = button.getAttribute('data-contact-form-program-type') || '';
        button.onclick = (event: MouseEvent) => {
            if (event) {
                event.preventDefault();
            }
            const cfPaymentTypeRequest: string = getCookie('Payment Type Request') || '';
            const cfPricingCurrency: string = getCookie('Pricing Currency') || '';
            return onClick({cfType, cfScrId, cfScrTitle, cfHref, cfFile, cfPPT, cfProgramType, cfPaymentTypeRequest, cfPricingCurrency});
        };

    });

    currentWindow.onload = () => {
        // console.log('######check cookie######');
        const utm_source = getUTMSource();
        if (utm_source) {
            saveUTMSourceCookie(utm_source);
        }
        if (!getCookie(Config.ADCORE_CONTACT_FORM_COOKIE)) {
            const initObject: any = {
                client_id: '230530490489-nqm7nta5rcvsbnmutuu62kl8edgnrjo9.apps.googleusercontent.com',
                callback: handleOneTapGoogleCredentialResponse,
                context: 'signin',
                auto_select: true,
                cancel_on_tap_outside: false,
                close_on_tap_outside: false,
                ux_mode: 'popup',
                prompt_parent_id: 'g_id_onload'
            };
            currentGoogle.accounts.id.initialize(initObject);
            currentGoogle.accounts.id.prompt((notify: any) => {
                // console.log('notification: ',  {
                //     isDisplayMoment: notify.isDisplayMoment(),
                //     isDisplayed: notify.isDisplayed(),
                //     isNotDisplayed: notify.isNotDisplayed(),
                //     getNotDisplayedReason: notify.getNotDisplayedReason(),
                //     isSkippedMoment: notify.isSkippedMoment(),
                //     getSkippedReason: notify.getSkippedReason(),
                //     isDismissedMoment: notify.isDismissedMoment(),
                //     getDismissedReason: notify.getDismissedReason(),
                //     getMomentType: notify.getMomentType()
                // }, "prompting after delay");
            });

            if (!getCookie(Config.ADCORE_CONTACT_FORM_COOKIE_30_MINUTES)) {
                const currentURL: string = (currentLocation) ? currentLocation.href || '' : '';
                const hiddenDelayElements: HTMLElement[] = currentDocument.querySelectorAll('[data-contact-form-hidden-delay]');
                const e = (hiddenDelayElements && hiddenDelayElements.length) ? hiddenDelayElements[0] : null;
                // console.log(' currentWindow.onload: ', {currentURL, e});
                // public_html/wp-content/themes/sentrysite-corporate/category-blog.php
                // public_html/wp-content/themes/sentrysite-corporate/single.php
                if (e || currentURL.includes('/blog/')) {
                    const delay = (e) ? e.getAttribute('data-contact-form-hidden-delay') || '10000' : '10000';
                    const cfType: string = (e) ? e.getAttribute('data-contact-form-type') || 'blogPopup' : 'blogPopup';
                    const cfScrId: string = (e) ? e.getAttribute('data-contact-form-screen-id') || 'blog_form' : 'blog_form';
                    const cfProgramType: string = (e) ? e.getAttribute('data-contact-form-program-type') || 'Blog subscribers' : 'Blog subscribers';
                    const cfScrTitle = '';
                    const cfHref = '';
                    const cfFile = '';
                    const cfPPT = '';
                    const cfPaymentTypeRequest = '';
                    const cfPricingCurrency = '';
                    // console.log(' currentWindow.onload before time out: ', {currentURL, delay});
                    setTimeout(() => {
                        // console.log(' currentWindow.onload before onClick', {currentURL, delay});
                        return onClick({
                            cfType,
                            cfScrId,
                            cfScrTitle,
                            cfHref,
                            cfFile,
                            cfPPT,
                            cfProgramType,
                            cfPaymentTypeRequest,
                            cfPricingCurrency
                        });
                    }, parseInt(delay));
                }
            }

        }
    };

};



// WEBPACK FOOTER //
// ./src/lib/opener.ts